module.exports = __webpack_public_path__ + "img/department.e3d2dc08.png";